import { effect, inject, Injectable, signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ResolveEnd, Router } from '@angular/router';

import { RouteNameEnum } from '@connect-services/client/models/routes.model';
import { RouterService } from '@connect-services/client/services/router.service';

@Injectable({
    providedIn: 'root',
})
export class GlobalSearchService {
    public columnsToSearchValueIn: string[] = [];
    public readonly hide: WritableSignal<boolean> = signal(false);
    public readonly searchValue: WritableSignal<string | null> = signal(null);

    private readonly router = inject(Router);
    private readonly routerService = inject(RouterService);

    public constructor() {
        const routerEvent = toSignal(this.router.events);

        effect(() => {
            if (routerEvent() instanceof ResolveEnd) {
                this.reset();
            }
        });
    }

    public setSearchProperties(): void {
        const routeName = this.routerService.getCurrentRoute();
        if (!routeName()) {
            throw new Error('Route not found');
        }

        switch (routeName()) {
            case RouteNameEnum.USERS:
            case RouteNameEnum.USERS_ROLES:
            case RouteNameEnum.SETTINGS:
                this.columnsToSearchValueIn = ['givenName', 'familyName', 'email'];
                break;
            case RouteNameEnum.ORGANIZATION_DATA:
            case RouteNameEnum.ROLES:
                this.columnsToSearchValueIn = ['name'];
                break;
            case RouteNameEnum.FORMS:
                this.columnsToSearchValueIn = ['name', 'description'];
                break;
            case RouteNameEnum.NOTIFICATION:
                this.columnsToSearchValueIn = ['familyName', 'givenName'];
                break;
            default:
                this.columnsToSearchValueIn = [];
        }
    }

    private reset(): void {
        this.searchValue.set(null);
    }
}
